import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  FormField as BronsonReactFormField,
  ErrorMessage,
  InfoIcon,
  FormField,
  Input,
  IconName,
} from '@vwfs-bronson/bronson-react'
import { Field } from 'formik'
import get from 'lodash/get'

export function FormFieldInput({
  name,
  labelText,
  labelForId,
  formProps,
  disabled,
  onChange,
  addonText,
  noBackground,
  readOnly,
  defaultValue,
  required = false,
  autoComplete = 'off',
  placeholder,
  mandatory
}) {
  const { t } = useTranslation()
  return (
    <Field name={name}>
      {({ field, form }) => {
        return (
          <FormField
            name={name}
            type="input"
            labelText={labelText}
            labelForId={labelForId ?? name}
            noFloatingLabel
            errorMessage={
              get(form.errors, name) && get(form.touched, name) ? (
                <ErrorMessage id={name} role="alert">
                  {get(form.touched, name) && get(form.errors, name)}
                </ErrorMessage>
              ) : (
                ''
              )
            }
            required={required ? 'true' : 'false'}
            aria-label={required ? labelText + mandatory : labelText}
            requiredText={required ? '' : t('personalDetails:optionalMessage')}
          >
            <Input
              {...field}
              id={name}
              name={name}
              error={
                !!(get(form.touched, name) ? get(form.errors, name) : undefined)
              }
              disabled={disabled}
              onChange={
                onChange ?? (e => formProps.setFieldValue(name, e.target.value))
              }
              onBlur={() => formProps.setFieldTouched(name, true)}
              addonText={addonText}
              noBackground={noBackground}
              readOnly={readOnly}
              value={defaultValue ?? formProps.values[name] ?? ''}
              required={required}
              aria-label={required ? labelText + mandatory : labelText}
              autoComplete={autoComplete}
              placeholder={placeholder}
            />
          </FormField>
        )
      }}
    </Field>
  )
}

export function BrFormField({
  render,
  name,
  labelElement = 'label',
  labelText,
  hint,
  infoIcon,
  notion,
  type = 'input',
  className,
  testId,
  noFloatingLabel = false,
  autoComplete = 'off',
}) {
  return (
    <Field name={name}>
      {({ field, form }) => (
        <BronsonReactFormField
          testId={testId}
          className={className}
          labelElement={labelElement || 'label'}
          labelText={
            <>
              {labelText}
              {notion && '*'}
              {infoIcon && (
                <InfoIcon icon={IconName.INFO} role="tooltip">
                  {infoIcon}
                </InfoIcon>
              )}
            </>
          }
          type={type}
          errorMessage={
            get(form.errors, name) && get(form.touched, name) ? (
              <ErrorMessage id={name}>
                {get(form.touched, name) && get(form.errors, name)}
              </ErrorMessage>
            ) : (
              ''
            )
          }
          hint={hint}
          noFloatingLabel={noFloatingLabel}
        >
          {render({
            name,
            error: !!(get(form.touched, name) && get(form.errors, name)),
            autoComplete,
            ...field,
          })}
        </BronsonReactFormField>
      )}
    </Field>
  )
}
